/// <amd-module name="Build/Common/Artifacts/Common" />
import { BuildArtifact } from 'Build/Client/Contracts/Build';

export namespace BuildArtifactTypes {
    export const FilePath = "FilePath".toLowerCase();
    export const SymbolStore = "SymbolStore".toLowerCase();
    export const VersionControl = "VersionControl".toLowerCase();
    export const Container = "Container".toLowerCase();
    export const GitRef = "GitRef".toLowerCase();
    export const TfvcLabel = "TfvcLabel".toLowerCase();
    export const SymbolRequest = "SymbolRequest".toLowerCase();
    export const PipelineArtifact = "PipelineArtifact".toLowerCase();
    export const Unknown = "Unknown".toLowerCase();
}

export interface IDisplayOptions {
    /**
     * IconName from office fabric font https://fabricicons.azurewebsites.net/
     */
    iconName: string;
    /**
     * Text to display
     */
    text: string;
    /**
     * Tooltip to display
     */
    tooltip: string;
    /**
     * Type of artifact
     */
    type: string;
}

export interface IArtifactProvider {
    /**
     * Gets the artifact send to the provider
     */
    getArtifact(): BuildArtifact;
    /**
     * Gets the download URL
     */
    getDownloadURL(): string;
    /**
     * Set to false if this type doesn't support any kind of download experience
     */
    supportsDownload(): boolean;
    /**
     * Set to false if this type doesn't support any kind of exploring experience
     */
    supportsExploring(): boolean;
    /**
     * Icon, text etc., to display
     */
    getDisplayOptions(): IDisplayOptions;
    /**
     * Implement this to handle custom download, by default we consider artifact resource's download URL, if supportsDownload is true
     */
    onDownload(): void;
    /**
     * Handle exploring artifacts, if supportsExploring is true
     */
    onExplore(): void;
    /**
     * Obtain the context for this artifact provider
     */
    getProviderContext(): ArtifactProviderContext;
}

/**
 * An companion object for artifact provider that contains contextual information such as project and build id.
 */
export interface ArtifactProviderContext {
    buildId: number | null;
    projectId: string;
}
